export const CHAT_API_LIMIT = 1000;
